'use client'

import React, { useEffect } from 'react'
import { useMemoryPreloader, setGlobalMemoryPreloader } from '@/hooks/useMemoryPreloader'
import { supabase } from '@/integrations/supabase/client'

type Props = { children: React.ReactNode }

export default function MemoryPreloaderProvider({ children }: Props) {
  const preloader = useMemoryPreloader()

  useEffect(() => {
    setGlobalMemoryPreloader(preloader)

    // Only preload if user is authenticated and not already loading
    const warmCache = async () => {
      if (preloader.isLoading) {
        return // Don't start another preload if one is already running
      }

      try {
        const { data: { session } } = await supabase.auth.getSession()
        const user = session?.user
        if (user) {
          console.log('[MEMORY] Starting preload for authenticated user:', user.id)
          preloader.preloadUserData().catch((error) => {
            console.error('[MEMORY] Preload failed:', error)
          })
        } else {
          console.log('[MEMORY] No authenticated user, skipping preload')
        }
      } catch (error) {
        console.error('[MEMORY] Auth check failed:', error)
      }
    }

    warmCache()

    return () => {
      // do not unset to allow persistence across hot reloads; no-op
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Remove preloader dependency to prevent re-running

  return <>{children}</>
}


